import styled from '@emotion/styled';
import { CustomTheme } from '@tajawal/ct-web-design-system/dist/theme';

const StateWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

const OtherAirportTitle = styled.div`
  display: flex;
  gap: 3px;
`;

const OtherAirportState = styled.div`
  padding-left: 27px;
  margin-top: 10px;
`;

const Img = styled.img`
  width: 24px;
  height: 24px;
  transform: ${({ theme }: { theme?: CustomTheme }) => theme.isRtl && 'rotateY(180deg)'};
`;

export default {
  Img,
  StateWrapper,
  OtherAirportTitle,
  OtherAirportState,
};
